import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { get, isEmpty, isNil } from 'lodash';

export function TextEditorRequiredValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const { value } = control;

    if (
      isNil(value) ||
      isEmpty(value) ||
      (get(value, 'content.length') === 1 && !get(value, 'content.0.content')) ||
      (typeof value === 'string' && !doInputGenerateVisibleText(value))
    ) {
      return { required: true };
    }

    return null;
  };
}

export function doInputGenerateVisibleText(html: string): boolean {
  const container = document.createElement('div');
  container.innerHTML = html.trim();

  return Boolean(container.textContent?.trim());
}
